var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIc19(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "10.7816mm",
    height: "6.932mm",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 1460.96 939.32",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_2465263003840"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillRule: "nonzero",
    y: 909.21,
    width: 1460.97,
    height: 30.11
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M1460.96 441.71l-374.64 0 0 -441.69 30.11 0 0 411.58 344.54 0 0 30.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M374.31 441.71l-374.31 0 0 -30.11 344.18 0 0 -411.58 30.12 0 0 441.69z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillRule: "nonzero",
    x: 455.67,
    y: 198.27,
    width: 558.22,
    height: 30.11
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M928.21 322.68l-21.15 -21.15 88.19 -88.2 -88.19 -88.19 21.15 -21.17 109.7 109.35 -109.7 109.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M543.86 322.68l-109.33 -109.35 109.33 -109.35 21.52 21.17 -88.2 88.19 88.2 88.2 -21.52 21.15z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillRule: "nonzero",
    x: 715.25,
    y: 0.01,
    width: 30.11,
    height: 90.34
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillRule: "nonzero",
    x: 715.25,
    y: 165.28,
    width: 30.11,
    height: 96.09
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillRule: "nonzero",
    x: 715.25,
    y: 336.3,
    width: 30.11,
    height: 90.34
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc19);
export default __webpack_public_path__ + "static/media/ic_1_9.3e9f4bb0b62ca372e44f82b2b4c80e74.svg";
export { ForwardRef as ReactComponent };